import React, { useEffect } from "react";
import {
  Container,
} from "reactstrap";

import withRouter from "Components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "Components/Common/Breadcrumb";
import OrganizationProfile from "./Organization";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

const UserProfile = () => {
  
  //meta title
  document.title = "Хувийн мэдээлэл засах";

  const selectProperties = createSelector(
    (state: any) => state.auth.user,
    (userInfo) => ({
      user: userInfo?.user,
    })
  );
  const { user } = useSelector(selectProperties);
  
  useEffect(() => {
    console.log(user);
  }, [user]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Профайл" breadcrumbItem="Хувийн мэдээлэл засах" />
          {/* {user?.legalEntity?.type_id === 10 ? 
            <PersonProfile personInfo={user}/> 
              : 
            } */}
            <OrganizationProfile personInfo={user}/>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
